import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="auto-reload-turbo-frame"
export default class extends Controller {
  static values = {
    interval: { type: Number, default: 5000 },
    disabled: { type: Boolean, default: false }
  }

  connect () {
    this.interval = window.setInterval(() => {
      if (this.disabledValue) return
      this.element.reload()
    }, this.intervalValue)
  }

  disconnect () {
    window.clearInterval(this.interval)
  }
}
